<template>
  <div class="status-reply">
    <user-byline
      v-if="reply.user"
      :user="reply.user"
      :date="reply.insertedAt"
      :show-preposition="false"
      show-date
    />
    <div class="status-reply__body">
      <component :is="bodyWithMentions" v-if="bodyWithMentions.template" />
      <p v-else v-html="body" />
    </div>
    <div class="status-reply__engagement">
      <status-engagement-bar
        :status="status"
        :reply="reply"
        :is-child-reply="isChildReply"
        :limit="limit"
      />
    </div>
    <status-child-replies
      v-if="reply.replies && reply.replies.length > 0"
      :replies="reply.replies"
      :status="status"
      :parent-reply-id="parentReplyId"
    />
  </div>
</template>

<script>
import UserByline from '@/components/User/UserByline.vue';
import InlineMention from '@/components/Mention/InlineMention.vue';
import parseMentionsMixin from '@/mixins/parse-mentions-mixin';
import StatusEngagementBar from '@/components/User/Statuses/StatusEngagementBar.vue';
import StatusChildReplies from '@/components/User/Statuses/StatusChildReplies.vue';

export default {
  name: 'StatusReply',
  components: {
    UserByline,
    StatusEngagementBar,
    StatusChildReplies,
    InlineMention,
  },
  mixins: [parseMentionsMixin],
  props: {
    reply: {
      type: Object,
      required: true,
    },
    status: {
      type: Object,
      required: true,
    },
    // This prop has to be passed through to StatusReplyForm so that we can query apollo cache
    limit: {
      type: Number,
      default: null,
    },
    isChildReply: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    parentReplyId() {
      return this.reply.inReplyTo ? this.reply.inReplyTo.id : this.status.id;
    },
    body() {
      // Remove unicode whitespace that surrounds mentions for IE11 and older Edge
      const regexp = new RegExp(/[\u2063]/, 'g');
      return this.reply.body.replace(regexp, '');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_status-reply';
</style>

<style lang="scss"> // no scoped - to reach class used in status
  .status-reply__body a:focus {
    @include highlighter-focus();
  }
</style>

<docs>
A single Reply that displays on a Status. Recursively rendered in StatusChildReplies.

</docs>
